//@flow
import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import { uniqueId } from 'lodash';
import theme from './style.scss';

type Props = {
    checked: boolean,
    label: string,
    onChange: (isChecked: boolean, event: Object) => void,
    disabled: boolean,
    ['data-test-id']: ?string
};

class Checkbox extends Component<Props> {
    static defaultProps = {
        checked: true,
        disabled: false
    };

    constructor(props) {
        super(props);
        this.id = uniqueId('checkbox_');
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.label !== this.props.label;
    }

    toggleCheckboxChange = e => {
        const { onChange } = this.props;
        const { checked } = e.target;
        setTimeout(() => {
            onChange(checked, e);
        }, 0);
    };

    render() {
        const { label, theme, disabled, checked, className } = this.props;
        return (
            <>
                <input
                    className={theme.checkbox}
                    type="checkbox"
                    value={label}
                    defaultChecked={checked}
                    onChange={this.toggleCheckboxChange}
                    id={this.id}
                    disabled={disabled}
                />
                <label
                    for={this.id}
                    className={className}
                    data-test-id={this.props['data-test-id']}
                >
                    {label}
                </label>
            </>
        );
    }
}

export default themr('Checkbox', theme)(Checkbox);
